module.exports = __webpack_public_path__ + "img/knife2.4d3815fb.png";